import moment from '~/Providers/Moment';
import { DATE_TIME_FORMAT } from '~/Redux/Constants';

export const onlyTime = dateTime => {
  const momentTime = moment(dateTime, DATE_TIME_FORMAT);
  let pieces = ['h'];
  if (momentTime.minutes() !== 0) pieces.push(':mm');
  if (momentTime.hour() >= 12) pieces.push('p');
  return momentTime.format(pieces.join(''));
};
